const initConfiguration = {
  gradientColor1: "#fff",
  gradientColor2: "#fff",
  headerText: "Psa Contact Validation",
  headerColor: "black",
  successMessageText: "You pass the verification. Close this window",
  successMessageColor: "#0e601c",
  failedMessageText: "You do not pass the validation.",
  failedMessageColor: "#b11212",
};

export default initConfiguration;
